import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, Image, ScrollView, View } from 'react-native';
import Colors from '../../constants/Colorsv2';
import { market_getMyCollectableRebates } from '../../store/actionsv1/markets';
import { PlayerCommissionRebateProps } from '../../store/types/mk_svc';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import moment from 'moment';
import { Icon } from 'react-native-elements';

const ActivityRebateScreen = ({route, navigation}:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ player_commission_rebates, setPlayerCommissionRebates ] = useState<PlayerCommissionRebateProps[]>([])

    useEffect(() => {
        getDataFromServer()
    },[])

    const getDataFromServer = async() => {
        setLoading(true);
        const player_commission_rebates = await market_getMyCollectableRebates()
        setPlayerCommissionRebates(player_commission_rebates)
        setLoading(false);
    }


    const renderRebates = (data: { item: PlayerCommissionRebateProps, index: number }) => {
        return (
            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }} onPress={() => navigation.push('ActivityRebate', { player_commission_rebate_id: data.item.player_commission_rebate_id })}>
                <View style={{ flex:1 }}>
                    <Text size={14} color={Colors.brand.slate}>Rebate Month</Text>
                    <Text style={{ marginTop:4 }} size={18} color={Colors.brand.midnight} weight='bold'>{moment.utc(data.item.rebate_month).format('MMMM YYYY')}</Text>
                </View>
                <View style={{ marginRight:10 }}>
                    <Text size={18} color={Colors.utility.success} weight='bold'>${data.item.rebate_amt.toFixed(2)}</Text>
                </View>
                <Icon type='feather' name='chevron-right' size={16} color={Colors.brand.midnight} />
            </TouchableOpacity>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <View nativeID='header' style={{ padding:20, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                <Text textAlign='center' size={24} color={Colors.brand.midnight} weight='bold'>My Collectable Rebates</Text>
            </View>
            <ScrollView style={{ flex:1 }}>
                {loading ?
                <ActivityIndicator style={{ padding:20, alignSelf: 'center' }} size='large' color={Colors.brand.midnight} />
                :<></>}
                <FlatList
                    data={player_commission_rebates.sort((a,b) => moment(a.rebate_month).unix() - moment(b.rebate_month).unix())}
                    renderItem={renderRebates}
                    keyExtractor={(item) => item.player_commission_rebate_id.toString()}
                />
                {!loading && player_commission_rebates.length == 0 ?
                <View style={{justifyContent:'center', alignItems:'center', padding:20}}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698862064/open_box_nryphw.png' }}
                        style={{ width: 200, height: 200 }}
                        resizeMode='contain'
                    />
                    <Text size={16} weight='bold' textAlign='center' color={Colors.brand.midnight}>All rebates have been collected!</Text>
                </View>
                :<></>}
            </ScrollView>
        </View>
    )
}

export default ActivityRebateScreen